var _rect, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWiringDiagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#6D7D8B",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 15.1667C8.5 12.024 8.5 10.4526 9.47631 9.47631C10.4526 8.5 12.024 8.5 15.1667 8.5H16.8333C19.976 8.5 21.5474 8.5 22.5237 9.47631C23.5 10.4526 23.5 12.024 23.5 15.1667V16.8333C23.5 19.976 23.5 21.5474 22.5237 22.5237C21.5474 23.5 19.976 23.5 16.8333 23.5H15.1667C12.024 23.5 10.4526 23.5 9.47631 22.5237C8.5 21.5474 8.5 19.976 8.5 16.8333V15.1667Z",
    stroke: "#6D7D8B",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8332 17.3212L21.8163 17.3043C21.4916 16.9796 21.2115 16.6995 20.9614 16.4887C20.6973 16.2662 20.4099 16.0704 20.0555 15.9635C19.5846 15.8215 19.0822 15.8215 18.6113 15.9635C18.257 16.0704 17.9695 16.2662 17.7054 16.4887C17.4554 16.6995 17.1753 16.9796 16.8506 17.3043L16.8268 17.328C16.5711 17.5837 16.4206 17.733 16.3038 17.8296L16.287 17.8432L16.2765 17.8243C16.204 17.6913 16.1197 17.4968 15.9772 17.1644L15.9327 17.0606L15.9143 17.0176C15.6177 16.3254 15.3686 15.7442 15.1221 15.3062C14.8681 14.8548 14.5516 14.4316 14.0583 14.1843C13.6468 13.978 13.1863 13.8893 12.7277 13.928C12.1778 13.9744 11.7267 14.2499 11.3233 14.5746C10.9855 14.8465 10.6064 15.2166 10.1668 15.655V16.8333C10.1668 17.2639 10.167 17.654 10.1693 18.0092L11.0976 17.081C11.6719 16.5067 12.0554 16.1248 12.3683 15.8729C12.6774 15.6242 12.8104 15.5936 12.8678 15.5888C13.0207 15.5759 13.1742 15.6054 13.3114 15.6742C13.3629 15.7 13.475 15.7778 13.6696 16.1236C13.8666 16.4736 14.0809 16.9706 14.4008 17.7171L14.4453 17.821L14.4589 17.8527C14.583 18.1423 14.6983 18.4114 14.8133 18.6224C14.9339 18.8434 15.109 19.1083 15.404 19.2908C15.7517 19.5061 16.1665 19.586 16.5693 19.5153C16.911 19.4553 17.1719 19.2744 17.366 19.1139C17.5512 18.9608 17.7581 18.7538 17.9809 18.531L17.9809 18.531L18.0053 18.5066C18.3605 18.1514 18.5903 17.9226 18.7795 17.7632C18.9606 17.6105 19.0461 17.5732 19.0927 17.5592C19.2497 17.5118 19.4171 17.5118 19.5741 17.5592C19.6207 17.5732 19.7062 17.6105 19.8874 17.7632C20.0765 17.9226 20.3063 18.1514 20.6615 18.5066L21.7869 19.6319C21.8252 19.0337 21.832 18.29 21.8332 17.3212Z",
    fill: "#6D7D8B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.75,
    cy: 12.25,
    r: 1.25,
    fill: "#6D7D8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiringDiagram);
export default __webpack_public_path__ + "static/media/wiringDiagram.33f426be.svg";
export { ForwardRef as ReactComponent };